import React, { useCallback, useRef, useState } from "react";
import ReactDOM from 'react-dom'
import { HexColorPicker } from "react-colorful";
import { useClickOutside } from "src/util/util";
import styled from "styled-components";
import { usePopper } from 'react-popper';
import { theme } from "src/config";

type ColorPickerProps = {
  onClick?: (e?: any) => void;
  onClose?:  (color: any) => void;
  value?:     string;
  label?:     string;
}


export const ColorPicker = ({ value, onClose, label } : ColorPickerProps) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement,    setPopperElement]    = useState(null);
  const [arrowElement,     setArrowElement]     = useState(null);
  const [color, setColor] = React.useState<string>(value);

  const containerRef = React.useRef<HTMLDivElement>(null);

  const { styles, attributes, forceUpdate } = usePopper(referenceElement, popperElement, {
    // strategy: 'fixed',
    placement: 'right',
    modifiers: [
      { name: 'arrow', options: { element: arrowElement } },
      { name: 'offset', options: { offset: [0, 8]}},
      { name: 'preventOverflow'}
    ],
  });

  const [isOpen, toggle] = useState(false);
  const close   = useCallback(() => {
    toggle(false);
    onClose(color);
  }, [color]);
  useClickOutside(containerRef, close);

  React.useLayoutEffect(() => {
    if (isOpen) forceUpdate();
  }, [isOpen])

  return (
    <Picker ref={containerRef}>
      <Label>{label}</Label>
      <Swatch ref={setReferenceElement} style={{ backgroundColor: color }} onClick={() => toggle(!isOpen)} />
      
      <PopOver ref={setPopperElement} style={styles.popper} {...attributes.popper}>
        {isOpen && (
          <HexColorPicker color={color} onChange={setColor} />
        )}
        <div ref={setArrowElement} style={styles.arrow} />
      </PopOver>
    </Picker>
  );
};


const Picker = styled.div`
  position:        relative;
  display:         flex;
  z-index:         3;
  flex-direction:  row;
  align-items:     center;
  justify-content: flex-start;
`;

const Swatch = styled.div`
  width:         28px;
  height:        28px;
  margin-right:  2rem;
  border-radius: 0.3rem;
  border:        3px solid ${theme.color.white};
  box-shadow:    0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor:        pointer;
`;

const PopOver = styled.div`
  z-index:       501;
  border-radius: 9px;
  box-shadow:    0 6px 12px rgba(0, 0, 0, 0.15);
`

const Label = styled.div`
  margin-right: 0.5rem;
  font-size:    ${theme.font.size.small};
`;

